import BulletedList from '../src/BulletedList/index.tsx';
export default BulletedList;
